/**
 * Field limits mirrored from the REGAIN API schemas (`src/whats_new/schemas.py`).
 * Keep these in sync with the backend so validation fails in the form rather
 * than as a 422 from the server.
 */
export const UPDATE_LIMITS = {
  id: 128,
  title: 200,
  description: 3000,
  category: 64,
  content: 20000,
  visualType: 64,
  visualUrl: 2048,
  ctaLabel: 120
};

export const COMING_SOON_LIMITS = {
  id: 128,
  title: 200,
  category: 64
};

export const VISUAL_TYPES = ['image', 'video'];

/** The only categories used in the stored config. */
export const CATEGORIES = ['Enhancements', 'Major Updates'];

/** Accepted by the media upload endpoint once it lands. */
export const UPLOAD_ACCEPTED_TYPES = 'image/png,image/jpeg,image/gif,video/mp4,video/webm';

export const UPLOAD_DISABLED_TOOLTIP =
  'Media upload endpoint is not available yet. Paste a URL for now.';
